import { Component } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// importing all the themes

import Forgotpass from "themes/forgotpass-theme";
import Signintheme from "themes/signin-theme";

import Dashboardtheme from "themes/myprofile-theme";

import Pagenotfound from "Pages/404page";
import AdminProfile from "Pages/AdminProfile";
import AddCategory from "Pages/Profile/Category/Addcategory";
import CategoryDetails from "Pages/Profile/Category/ViewDetails";
import ChatSupport from "Pages/Profile/Chat";
import TermsconditionAU from "Pages/Profile/Cmspage/Cmscomponents/TermsconditionAU";
import AddFaqs from "Pages/Profile/Cmspage/Cmscomponents/faqs/AddFaqs";
import ViewEventViewDetails from "Pages/Profile/Events/ViewDetails";
import AllNotification from "Pages/Profile/Notification/AllNotification";
import ManageChangeRoleUsers from "Pages/Profile/Pendinguser/ChangeRoleRequests";
import ChatViewDetails from "Pages/Profile/Pendinguser/Pendingchatroom/ViewDetails";
import UserViewDetails from "Pages/Profile/Pendinguser/Users/ViewDetails";
import PitchViewDetails from "Pages/Profile/Pitches/ViewDetails";
import Posts from "Pages/Profile/Posts";
import PostViewDetails from "Pages/Profile/Posts/ViewDetails";
import AddSpeciality from "Pages/Profile/Speciality/Addspeciality";
import SpecialityDetails from "Pages/Profile/Speciality/ViewDetails";
import SupportIssues from "Pages/Profile/Support Isssues";
import AddIssues from "Pages/Profile/Support Isssues/AddIssues";
import Addtalent from "Pages/Profile/Talent/Addtalent";
import TalentDetails from "Pages/Profile/Talent/ViewDetails";
import Chnagepasstheme from "themes/chnagepass-theme";
import DashPosttheme from "themes/dashPost-theme";
import Dashaddeventtheme from "themes/dashaddevent-theme";
import Dashaddnotifytheme from "themes/dashaddnotify-theme";
import Dashaddsubadmintheme from "themes/dashaddsubadmin-theme";
import Dashboardpagetheme from "themes/dashboard-theme";
import Dashchatroomtheme from "themes/dashchatroom-theme";
import Dashcmspagetheme from "themes/dashcmspage-theme";
import Dashcustomerfeedbacktheme from "themes/dashcustomerfeedback-theme";
import Dashcustomersupporttheme from "themes/dashcustomersupport-theme";
import Dashdataanalyticstheme from "themes/dashdataanalytics-theme";
import Dasheventtheme from "themes/dashevent-theme";
import Dashmanageusertheme from "themes/dashmanageuser-theme";
import Dashnotificaitiontheme from "themes/dashnotificaition-theme";
import Dashpedingchatroomtheme from "themes/dashpedingchatroom-theme";
import Dashpendingusertheme from "themes/dashpending-usertheme";
import Dashpendingeventstheme from "themes/dashpendingevents-theme";
import Dashpitchtheme from "themes/dashpitch-theme";
import Dashpitchestheme from "themes/dashpitches-theme";
import Dashreportusertheme from "themes/dashreportuser-theme";
import Dashsubadmintheme from "themes/dashsubadmin-theme";
import DashCategoryPageTheme from "themes/dashtalent-category";
import DashSpecialityPageTheme from "themes/dashtalent-speciality";
import Dashtalentpagetheme from "themes/dashtalent-theme";

import AddIntro from "Pages/Profile/AppIntro/AddIntro";
import AppIntroViewDetails from "Pages/Profile/AppIntro/ViewDetails";
import ReportsIssues from "Pages/Profile/ReportsIssues";
import AddReportIssues from "Pages/Profile/ReportsIssues/AddReportIssues";
import DashappIntrotheme from "themes/dashappIntro-theme";

import RouteProtector from "./RouteProtector";
import { PERMISSION_KEYS } from "utilities/permissionConst";


const dashboardRoutes = [
  { path: "/", element: <Dashboardpagetheme /> },
  { path: "/profile", element: <AdminProfile /> },
  {
    path: "/pending-users",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.PENDING_USERS}>
        <Dashpendingusertheme />
      </RouteProtector>
    ),
  },
  {
    path: "/change-role-request",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CHANGE_ROLE_REQUEST}>
        <ManageChangeRoleUsers />
      </RouteProtector>
    ),
  },
  {
    path: "/pending-pitches",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.PENDING_PITCHES}>
        <Dashpitchestheme />
      </RouteProtector>
    ),
  },
  {
    path: "/pending-events",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.PENDING_EVENTS}>
        <Dashpendingeventstheme />
      </RouteProtector>
    ),
  },
  {
    path: "/pending-request-chatroom",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.PENDING_CHATROOM}>
        <Dashpedingchatroomtheme />
      </RouteProtector>
    ),
  },
  {
    path: "/pending-posts",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.PENDING_POSTS}>
        <DashPosttheme />
      </RouteProtector>
    ),
  },
  {
    path: "/manage-users",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.USER_PERMISSION}>
        <Dashmanageusertheme />
      </RouteProtector>
    ),
  },
  {
    path: "/view-user/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.USER_PERMISSION}>
        <UserViewDetails />
      </RouteProtector>
    ),
  },
  {
    path: "/view-post/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.POST_PERMISSION}>
        <PostViewDetails />
      </RouteProtector>
    ),
  },
  {
    path: "/events",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.EVENT_PERMISSION}>
        <Dasheventtheme />
      </RouteProtector>
    ),
  },
  {
    path: "/pitches",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.PITCH_PERMISSION}>
        <Dashpitchtheme />
      </RouteProtector>
    ),
  },
  {
    path: "/view-pitch/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.PITCH_PERMISSION}>
        <PitchViewDetails />
      </RouteProtector>
    ),
  },
  {
    path: "/posts",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.POST_PERMISSION}>
        <Posts />
      </RouteProtector>
    ),
  },
  {
    path: "/add-events",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.EVENT_PERMISSION}>
        <Dashaddeventtheme />
      </RouteProtector>
    ),
  },
  {
    path: "/edit-event/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.EVENT_PERMISSION}>
        <Dashaddeventtheme />
      </RouteProtector>
    ),
  },
  {
    path: "/view-event/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.EVENT_PERMISSION}>
        <ViewEventViewDetails />
      </RouteProtector>
    ),
  },
  {
    path: "/chatroom",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CHATROOM_PERMISSION}>
        <Dashchatroomtheme />
      </RouteProtector>
    ),
  },
  {
    path: "/sub-admin",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.SUB_ADMIN_PERMISSION}>
        <Dashsubadmintheme />
      </RouteProtector>
    ),
  },
  {
    path: "/add-subadmin",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.SUB_ADMIN_PERMISSION}>
        <Dashaddsubadmintheme />
      </RouteProtector>
    ),
  },
  {
    path: "/edit-subadmin/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.SUB_ADMIN_PERMISSION}>
        <Dashaddsubadmintheme />
      </RouteProtector>
    ),
  },
  {
    path: "/notification",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.NOTIFICATION_PERMISSION}>
        <Dashnotificaitiontheme />
      </RouteProtector>
    ),
  },
  {
    path: "/add-notification",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.NOTIFICATION_PERMISSION}>
        <Dashaddnotifytheme />
      </RouteProtector>
    ),
  },
  {
    path: "/data-analytics",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.DATA_ANALYTICS_PERMISSION}>
        <Dashdataanalyticstheme />
      </RouteProtector>
    ),
  },
  {
    path: "/customer-support",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CUSTOMER_SUPPORT_PERMISSION}>
        <Dashcustomersupporttheme />
      </RouteProtector>
    ),
  },
  {
    path: "/customer-feedback",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CUSTOMER_FEEDBACK_PERMISSION}>
        <Dashcustomerfeedbacktheme />
      </RouteProtector>
    ),
  },
  {
    path: "/app-intro",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.APP_INTRO_PERMISSION}>
        <DashappIntrotheme />
      </RouteProtector>
    ),
  },
  {
    path: "/app-intro-view/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.APP_INTRO_PERMISSION}>
        <AppIntroViewDetails />
      </RouteProtector>
    ),
  },
  {
    path: "/add-app-intro",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.APP_INTRO_PERMISSION}>
        <AddIntro />
      </RouteProtector>
    ),
  },
  {
    path: "/edit-app-intro/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.APP_INTRO_PERMISSION}>
        <AddIntro />
      </RouteProtector>
    ),
  },
  {
    path: "/report-user",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.REPORT_USER_PERMISSION}>
        <Dashreportusertheme />
      </RouteProtector>
    ),
  },
  {
    path: "/report-issues",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.REPORT_USER_PERMISSION}>
        <ReportsIssues />
      </RouteProtector>
    ),
  },
  {
    path: "/add-report-issues",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.REPORT_USER_PERMISSION}>
        <AddReportIssues />
      </RouteProtector>
    ),
  },
  {
    path: "/edit-report-issues/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.REPORT_USER_PERMISSION}>
        <AddReportIssues />
      </RouteProtector>
    ),
  },
  {
    path: "/cms",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CMS_ADMIN_PERMISSION}>
        <Dashcmspagetheme />
      </RouteProtector>
    ),
  },
  {
    path: "/add-cms",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CMS_ADMIN_PERMISSION}>
        <TermsconditionAU />
      </RouteProtector>
    ),
  },
  {
    path: "/edit-cms/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CMS_ADMIN_PERMISSION}>
        <TermsconditionAU />
      </RouteProtector>
    ),
  },
  {
    path: "/add-faqs",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CMS_ADMIN_PERMISSION}>
        <AddFaqs />
      </RouteProtector>
    ),
  },
  {
    path: "/edit-faqs/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CMS_ADMIN_PERMISSION}>
        <AddFaqs />
      </RouteProtector>
    ),
  },
  {
    path: "/view-chat-room/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CHATROOM_PERMISSION}>
        <ChatViewDetails />
      </RouteProtector>
    ),
  },
  {
    path: "/all-notification",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.NOTIFICATION_PERMISSION}>
        <AllNotification />
      </RouteProtector>
    ),
  },
  {
    path: "/chat-support",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CHATROOM_PERMISSION}>
        <ChatSupport />
      </RouteProtector>
    ),
  },
  {
    path: "/support-issues",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CUSTOMER_SUPPORT_PERMISSION}>
        <SupportIssues />
      </RouteProtector>
    ),
  },
  {
    path: "/add-support-issues",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CUSTOMER_SUPPORT_PERMISSION}>
        <AddIssues />
      </RouteProtector>
    ),
  },
  {
    path: "/edit-support-issues/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CUSTOMER_SUPPORT_PERMISSION}>
        <AddIssues />
      </RouteProtector>
    ),
  },
  {
    path: "/talent",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.TALENT_PERMISSION}>
        <Dashtalentpagetheme />
      </RouteProtector>
    ),
  },
  {
    path: "/add-talent",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.TALENT_PERMISSION}>
        <Addtalent />
      </RouteProtector>
    ),
  },
  {
    path: "/edit-talent/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.TALENT_PERMISSION}>
        <Addtalent />
      </RouteProtector>
    ),
  },
  {
    path: "/view-talent/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.TALENT_PERMISSION}>
        <TalentDetails />
      </RouteProtector>
    ),
  },
  {
    path: "/speciality",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.SPECIALITY_PERMISSION}>
        <DashSpecialityPageTheme />
      </RouteProtector>
    ),
  },
  {
    path: "/add-speciality",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.SPECIALITY_PERMISSION}>
        <AddSpeciality />
      </RouteProtector>
    ),
  },
  {
    path: "/edit-speciality/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.SPECIALITY_PERMISSION}>
        <AddSpeciality />
      </RouteProtector>
    ),
  },
  {
    path: "/view-speciality/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.SPECIALITY_PERMISSION}>
        <SpecialityDetails />
      </RouteProtector>
    ),
  },
  {
    path: "/category",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CATEGORY_PERMISSION}>
        <DashCategoryPageTheme />
      </RouteProtector>
    ),
  },
  {
    path: "/add-category",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CATEGORY_PERMISSION}>
        <AddCategory />
      </RouteProtector>
    ),
  },
  {
    path: "/edit-category/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CATEGORY_PERMISSION}>
        <AddCategory />
      </RouteProtector>
    ),
  },
  {
    path: "/view-category/:id",
    element: (
      <RouteProtector permissionKey={PERMISSION_KEYS.CATEGORY_PERMISSION}>
        <CategoryDetails />
      </RouteProtector>
    ),
  },
];

class MyRouts extends Component {
  render() {
    return (
      <div>
        <BrowserRouter>
          <Routes>
            {!this.props?.isAuthenticated ? (
              <>
                <Route path="/" element={<Signintheme />} />
                <Route path="/forgot-password" element={<Forgotpass />} />
                <Route path="/change-password" element={<Chnagepasstheme />} />
                <Route path="*" element={<Pagenotfound />} />
              </>
            ) : (
              <>
                <Route element={<Dashboardtheme />}>
                  {dashboardRoutes.map((route) => (
                    <Route
                      key={route.path}
                      path={route.path}
                      element={route.element}
                    />
                  ))}
                </Route>

                <Route path="*" element={<Pagenotfound />} />
              </>
            )}
          </Routes>
        </BrowserRouter>
      </div>
    );
  }
}
export default MyRouts;
